import script from "./MyWorks.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyWorks.vue?vue&type=script&setup=true&lang=ts"

import "./MyWorks.vue?vue&type=style&index=0&id=9742f80c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9742f80c"]])

export default __exports__